import * as React from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { spacing } from 'styles/constants';

import { getQuestTermsText } from '../custom-text';

import { IQuestTermsProps } from './types';

export const QuestTerms = ({ cmsQuestTerms, hideHeading = false }: IQuestTermsProps) => {
  if (!cmsQuestTerms?.localeRaw) {
    return null;
  }

  return (
    <View
      style={[
        styles.container,
        hideHeading ? styles.containerNoHeading : styles.containerWithHeading,
      ]}
    >
      {!hideHeading && <Typography variant="headerThree">{getQuestTermsText()}</Typography>}
      <SanityBlockRenderer textProps={{ variant: 'copyOne' }} content={cmsQuestTerms.localeRaw} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: spacing.$4,
  },
  containerWithHeading: {
    marginTop: spacing.$8,
    marginBottom: spacing.$8,
  },
  containerNoHeading: {
    marginTop: 0,
    marginBottom: 0,
  },
});
